export default "__VITE_ASSET__D6L6f97S__"